import color from './color';

const shadow = {
  default: '0 8px 24px rgba(0, 0, 0, 0.12)',
  green: `0.6rem 0 0 ${color.green}, -0.6rem 0 0 ${color.green}`
};

export default shadow;
